import { combineReducers } from 'redux';

import { AuthReducer } from './auth';
import { MainReducer } from './main';
import { PaymentsReducers } from './payments';
import { UsersReducers } from './users';

const rootReducer = combineReducers({
    auth: AuthReducer,
    main: MainReducer,
    user: UsersReducers,
    payments: PaymentsReducers,
});

export default rootReducer;
